import { EditorView } from '@uiw/react-codemirror'
import { onEditAssetFacet } from './assetReferenceDecoration'

const UUID_AFTER = /^[0-9a-f]{8}-/i

export const assetTriggerExtension = EditorView.inputHandler.of((view, from, to, insert) => {
  if (insert !== '/') return false

  const line = view.state.doc.lineAt(from)
  const textBefore = line.text.slice(0, from - line.from)
  if (!textBefore.endsWith('asset:/')) return false

  const textAfter = view.state.doc.sliceString(to, Math.min(to + 9, view.state.doc.length))
  if (UUID_AFTER.test(textAfter)) return false

  const triggerFrom = from - 'asset:/'.length
  const triggerTo = to

  // Let the `/` insert normally, then fire callback asynchronously
  setTimeout(() => {
    const callback = view.state.facet(onEditAssetFacet)
    callback({ from: triggerFrom, to: triggerTo + 1 })
  }, 0)

  return false
})
